<template>
    <v-card color="primary" class="mx-auto mt-1">
        <v-card-text class="white--text">
            <v-flex xs12 class="text-center">
                <b>Cliente</b>
            </v-flex>
            <v-flex xs12>
                <b>Nome:</b> {{ item.client.name }}
            </v-flex>
            <v-flex xs12>
                <b>Endereço:</b> {{ item.client.address }}
            </v-flex>
            <v-flex xs12 v-if="item.client.cep">
                <b>CEP:</b> {{ item.client.cep }}
            </v-flex>
            <v-flex xs12 v-if="item.client.cpfOrCnpj">
                <b>{{ getCpfCnpjLabel }}:</b> {{ formatCpfCnpj(item.client.cpfOrCnpj) }}
            </v-flex>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true,
        }
    },
    computed: {
        getCpfCnpjLabel() {
            if (!this.item.client.cpfOrCnpj) return 'CPF/CNPJ';
            
            // Remove todos os caracteres não numéricos
            const numbers = this.item.client.cpfOrCnpj.replace(/\D/g, '');
            
            // CPF tem 11 dígitos, CNPJ tem 14 dígitos
            if (numbers.length === 11) {
                return 'CPF';
            } else if (numbers.length === 14) {
                return 'CNPJ';
            } else {
                return 'CPF/CNPJ';
            }
        }
    },
    methods: {
        formatCpfCnpj(value) {
            if (!value) return '';
            
            // Remove todos os caracteres não numéricos
            const numbers = value.replace(/\D/g, '');
            
            // Verifica se é CPF (11 dígitos)
            if (numbers.length === 11) {
                return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
            }
            // Verifica se é CNPJ (14 dígitos)
            else if (numbers.length === 14) {
                return numbers.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
            }
            // Se não tem 11 nem 14 dígitos, retorna sem formatação
            else {
                return value;
            }
        }
    }
};
</script>